import React from "react";
import { Link } from "react-router-dom";

const HomeLogin = () => {
  return (
    <div id="page-home-login">
      <div className="message-container">
        <h1>Bem-vindo ao Leroy Merlin com Você!</h1>
        <p>Clique no botão abaixo para continuar</p>
      </div>

      <Link to="/login">
        Login com o PingOne
        <span className="glyph glyph-double-arrow-right" />
      </Link>
    </div>
  );
};

export default HomeLogin;
